import { isBrazilMapAvailable } from '../../../utils/brazilMap';
import { BrazilMapSVG } from '../../Map/BrazilMap/BrazilMapSVG';
import styles from './RegionThumbnailCard.module.css';

interface RegionThumbnailCardProps {
	name: string;
	stateCodes: string[];
	onClick: () => void;
}

export const RegionThumbnailCard = ({ name, stateCodes, onClick }: RegionThumbnailCardProps) => (
	<div
		className={styles.card}
		onClick={onClick}
		role="button"
		tabIndex={0}
		onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
	>
		<div className={styles.mapContainer}>
			<div className={styles.mapWrapper}>
				{isBrazilMapAvailable ? <BrazilMapSVG selectedStateCodes={stateCodes} /> : stateCodes.join(', ')}
			</div>
		</div>
		<span className={styles.label}>{name}</span>
	</div>
);
